<template>
  <!--
    	作者：kmdshop
    	时间：2020-06-20
    	描述：diy组件-参数设置-导航组
    -->
  <div>
    <div class="common-form"><span>{{ curItem.name }}</span></div>
    <el-form size="small" :model="curItem" label-width="100px">
      <!--背景颜色-->
      <el-form-item label="背景颜色：">
        <div class="d-s-c">
          <el-color-picker v-model="curItem.style.background"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;" @click.stop="$parent.onEditorResetColor(curItem.style, 'btnColor', '#ffffff')">
            重置
          </el-button>
        </div>
      </el-form-item>
      <!--每行数量-->
      <el-form-item label="每行数量：">
        <el-radio-group v-model="curItem.style.rowsNum">
          <el-radio :label="1">1个</el-radio>
          <el-radio :label="3">3个</el-radio>
          <el-radio :label="4">4个</el-radio>
          <el-radio :label="5">5个</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="图片：">
        <draggable class="wrapper" v-model="curItem.data" :options="{ animation: 120, filter: '.drag__nomove' }">
          <div class="param-img-item" :key="index" v-for="(navBar, index) in curItem.data">
            <div class="delete-box">
              <i class="el-icon-delete-solid" @click="$parent.onEditorDeleleData(index, selectedIndex)"></i>
            </div>
            <!--背景颜色-->
            <el-form-item label="图标类型：">
              <!-- 选择图案还是icon -->
              <el-radio-group v-model="navBar.icon_type">
                <el-radio :label="10">图标</el-radio>
                <el-radio :label="20">图片</el-radio>
              </el-radio-group>
            </el-form-item>

            <div v-if="Number(navBar.icon_type) === 20">
              <div class="icon">
                <img v-img-url="navBar.imgUrl" alt="" @click="$parent.onEditorSelectImage(navBar, 'imgUrl')">
              </div>
              <p class="tc gray9">建议尺寸100x100</p>
            </div>
            <div v-else>
              <div class="url-box">
                <span class="key-name">图标：</span>
                <selectIcon :icon_text.sync="navBar.icon"></selectIcon>
              </div>
              <div class="url-box">
                <span class="key-name">图标颜色：</span>
                <el-radio-group v-model="navBar.colorConf" @change="colorConfChange" style="line-height: 40px">
                  <el-radio :label="30">默认主题色</el-radio>
                  <el-radio :label="10">纯色</el-radio>
                  <el-radio :label="20">渐变色</el-radio>
                </el-radio-group>
              </div>
              <div class="url-box" v-if="Number(navBar.colorConf) === 20">
                <span class="key-name">请选择：</span>
                <el-color-picker v-model="navBar.color1"></el-color-picker>
                <el-color-picker v-model="navBar.color2"></el-color-picker>
                <el-color-picker v-model="navBar.color3"></el-color-picker>
              </div>
              <div class="url-box" v-if="Number(navBar.colorConf) === 10">
                <span class="key-name">请选择：</span>
                <el-color-picker v-model="navBar.solidColor"></el-color-picker>
              </div>
            </div>


            <div class="url-box" style="width: 250px;">
              <span class="key-name">图片宽度：</span>
              <el-input v-model="navBar.img_width"
              placeholder="0为默认"
              style="width: 150px;"></el-input> <span style="margin-left: 10px;">rpx</span>
            </div>
 
            <div class="url-box" style="width: 250px;">
              <span class="key-name">图片高度：</span>
              <el-input v-model="navBar.img_height"
                placeholder="0为默认"
              style="width: 150px;"></el-input> <span style="margin-left: 10px;">rpx</span>
            </div>


            <div class="url-box">
              <span class="key-name">文字内容：</span>
              <el-input v-model="navBar.text"></el-input>
            </div>
            <div class="url-box">
              <span class="key-name">文字颜色：</span>
              <div class="d-s-c">
                <el-color-picker v-model="navBar.font_color"></el-color-picker>
                <el-button type="button" style="margin-left: 10px;" @click.stop="$parent.onEditorResetColor(curItem.style, 'btnColor', '#ffffff')">
                  重置
                </el-button>
              </div>
            </div>

        
            <div class="d-s-c">
              <div class="url-box flex-1">
                <span class="key-name">链接名称：</span>
                <el-input :value="navBar.name+navBar.linkUrl"></el-input>
              </div>
              <div class="url-box ml10">
                <el-button type="primary" @click="changeLink(index)">选择链接</el-button>
              </div>
            </div>
          </div>
        </draggable>
        <div class="d-c-c">
          <el-button @click="$parent.onEditorAddData">添加一个</el-button>
        </div>
      </el-form-item>
      <SetLink v-if="is_linkset" :is_linkset="is_linkset" @closeDialog="closeLinkSet">选择链接</SetLink>
    </el-form>

  </div>
</template>

<script>
import SetLink from '@/components/setlink/Setlink';
import draggable from "vuedraggable";
import selectIcon from "@/components/page/selectIcon";
export default {
  components: {
    SetLink,
    draggable,
    selectIcon,
  },
  data() {
    return {
      /*是否选择链接*/
      is_linkset: false,
      index: null,
    };
  },
  props: ['curItem', 'selectedIndex', 'opts'],
  methods: {
    /*选择链接*/
    changeLink(index) {
      this.is_linkset = true;
      this.index = index;
    },

    /*获取链接并关闭弹窗*/
    closeLinkSet(e) {
      if (e) {
        this.curItem.data[this.index].linkUrl = e.url;
        // this.curItem.data[this.index].name = e.name;
        this.curItem.data[this.index].name = '链接到' + ' ' + e.type + ' ' + e.name;
        if (e.appid) {
          this.curItem.data[this.index].appid = e.appid;
        }
      }
      this.is_linkset = false;
    },
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/NavBar.vue